/* eslint-disable standard/no-callback-literal */
import auth from "@/modules/auth/services/auth";
import axios from "axios";
import router from "@/modules/global/router";
import store from "@/modules/global/stores";
// eslint-disable-next-line no-unused-vars

var http = axios.create({
    baseURL: process.env.API_BASE_URL,
    headers: { "Content-Type": "application/json" },
});

http.interceptors.response.use(
    function (response) {
        return response;
    },

    function (error) {
        if (error.response.status !== 401) return Promise.reject(error);

        var refreshAndRetry = new Promise(function (resolve) {
            axios
                .post(
                    process.env.API_BASE_URL + "account/refresh_token",
                    {
                        // eslint-disable-next-line no-undef
                        refresh_token: JSON.parse(
                            localStorage.getItem("refresh_token")
                        ).value,
                    },
                    {
                        headers: {
                            "Content-Type": "application/json",
                            // eslint-disable-next-line no-undef
                            Authorization:
                                "Bearer " +
                                JSON.parse(localStorage.getItem("token")).value,
                        },
                    }
                )
                .then(function (response) {
                    // eslint-disable-next-line no-undef
                    localStorage.setItem(
                        "refresh_token",
                        JSON.stringify({
                            value: response.data.refresh_token,
                            expire: null,
                        })
                    );

                    // eslint-disable-next-line no-undef
                    localStorage.setItem(
                        "token",
                        JSON.stringify({
                            value: response.data.token,
                            expire: null,
                        })
                    );

                    return Promise.resolve(response);
                })
                .then(function (response) {
                    var failedRequest = error.config;
                    // eslint-disable-next-line no-undef
                    failedRequest.headers.Authorization =
                        "Bearer " +
                        JSON.parse(localStorage.getItem("token")).value;
                    axios.request(failedRequest).then(function (retryResponse) {
                        resolve(retryResponse);
                    });
                })
                .catch(function (err) {
                    var failedRequest = err.config;
                    // eslint-disable-next-line no-undef
                    var token = JSON.parse(localStorage.getItem("token")).value;
                    auth.doLogout(token, function (result) {
                        if (result.success) {
                            localStorage.clear();
                            store.commit("auth_destroyed");
                            router.push("/");
                        }
                    });

                    // eslint-disable-next-line no-undef
                    failedRequest.headers.Authorization =
                        "Bearer " +
                        JSON.parse(localStorage.getItem("token")).value;
                    axios.request(failedRequest).then(function (retryResponse) {
                        resolve(retryResponse);
                    });
                });
        });

        return refreshAndRetry;
    }
);

function getConfig() {
    return {
        headers: {
            // eslint-disable-next-line no-undef
            Authorization: JSON.parse(localStorage.getItem("token")).value,
        },
    };
}

function getListModul(params, callback) {
    var config = getConfig();
    var url = `itembank/module/admin/list?search=${params.search}&page=${params.page}&size=${params.size}`;

    if (params.bab) {
        url += `&bab=${encodeURIComponent(params.bab)}`;
    }

    if (params.grade) {
        url += `&grade=${params.grade}`;
    }

    if (params.subject) {
        url += `&subject=${encodeURIComponent(params.subject)}`;
    }

    if (params.kurikulum) {
        url += `&kurikulum=${params.kurikulum}`;
    }

    if (params.status) {
        url += `&status=${params.status}`;
    }

    http.get(url, config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function getCountModule(callback) {
    var config = getConfig();
    http.get("itembank/module/admin/get-count", config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function getModulBelajar(data, callback) {
    var config = getConfig();
    http.get("itembank/module/" + data, config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function createModulPembelajaran(data, callback) {
    var config = getConfig();
    var postData = {
        name: data.name,
        subject: data.subject,
        url: data.url,
        kurikulum: data.kurikulum,
        status_user: data.status_user,
        bab: data.bab,
        sub_bab: data.sub_bab,
        sub_sub_bab: data.sub_sub_bab,
        module_order: data.module_order,
        infografis_urls: data.infografis_urls,
        reading_material: data.reading_material,
        test_assembly: data.test_assembly,
        video_url: data.video_url,
        semester: data.semester,
        grades: data.grades,
        password: data.password,
        jenjang: data.jenjang,
        status: data.status,
        user_group: data.user_group,
    };

    http.post("itembank/module/create", postData, config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function assignTestModul(data, callback) {
    var config = getConfig();
    var postData = data.test_assembly;

    http.post(`itembank/module/${data.id}/testassembly/add`, postData, config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function assignInfografisModul(data, callback) {
    var config = getConfig();
    var postData = data.infografis;

    http.post(`itembank/infografis/${data.id}/add`, postData, config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function updateInfografisModul(data, callback) {
    var config = getConfig();
    var postData = [data.infografis];

    http.put(`itembank/infografis/${data.id}/update`, postData, config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function editModulPembelajaran(data, callback) {
    var config = getConfig();

    http.put("itembank/module/" + data.id + "/update", data, config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function deleteSoalModulBelajar(data, callback) {
    var config = getConfig();
    http.delete("itembank/module/testassembly/delete", {
        data: {
            test_assembly_ids: data,
        },
        headers: config.headers,
    })
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function deleteInfografisModulBelajar(data, callback) {
    var config = getConfig();
    http.delete("itembank/infografis/delete", {
        data: {
            infografis_ids: data,
        },
        headers: config.headers,
    })
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function deleteModulPembelajaran(data, callback) {
    var config = getConfig();
    http.delete("itembank/module/" + data + "/delete", config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function getListModulByBab(babId, grade, callback) {
    var config = getConfig();
    var url = `itembank/module/list/order?bab_id=${babId}`;

    if (grade) {
        url += `&grade=${grade}`;
    }

    http.get(url, config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

// API membalas HTTP 200 juga saat gagal; status di body "300" bila ada id tidak ditemukan
function changeSequence(dataBody, callback) {
    var config = getConfig();
    http.put("itembank/module/change/order", dataBody, config)
        .then(function (response) {
            callback({
                success: response.data.status == "200",
                data: response.data,
                message: response.data.description,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

export default {
    getListModul,
    getListModulByBab,
    changeSequence,
    getCountModule,
    getModulBelajar,
    createModulPembelajaran,
    assignTestModul,
    editModulPembelajaran,
    assignInfografisModul,
    updateInfografisModul,
    deleteSoalModulBelajar,
    deleteModulPembelajaran,
    deleteInfografisModulBelajar,
};



// WEBPACK FOOTER //
// ./src/modules/modul_belajar_2022/services/modulpembelajaran.js